
export default {
  name: 'Parallax',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    lqipSrc: {
      type: String,
      required: true,
    },
    speed: {
      type: String,
      default: '0.2',
    },
    position: {
      type: String,
      default: '50% 25%',
    },
    minHeight: {
      type: String,
      default: '600',
    },
  },
}
